import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { SeedCrop } from 'modules/domain/seedCrop/types'
import { EntityMetadata } from 'modules/domain/types'

const seedCropDicts = (state: AppGlobalState) => state.seedCrop.items
const ids = (state: AppGlobalState) => state.seedCrop.ids
const seedCrop = (state: AppGlobalState, id: string): SeedCrop | undefined => state.seedCrop.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<SeedCrop> =>
  state.seedCrop.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.seedCrop.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.seedCrop.listFetchProgress
const listFetchNextProgress = (state: AppGlobalState) => state.seedCrop.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.seedCrop.listFetchNextError
const listFetchError = (state: AppGlobalState) => state.seedCrop.listFetchError
const seedCropList = createSelector(seedCropDicts, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: SeedCrop[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.seedCrop.filter
const sorting = (state: AppGlobalState) => state.seedCrop.sorting
const page = (state: AppGlobalState) => state.seedCrop.page
const total = (state: AppGlobalState) => state.seedCrop.total
const updateProgress = (state: AppGlobalState) => state.seedCrop.updateProgress
const removeProgress = (state: AppGlobalState) => state.seedCrop.removeProgress
const addProgress = (state: AppGlobalState) => state.seedCrop.addProgress
const addError = (state: AppGlobalState) => state.seedCrop.addError
const hasNext = (state: AppGlobalState) => state.seedCrop.total > state.seedCrop.ids.length
const pageSize = (state: AppGlobalState) => state.seedCrop.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.seedCrop.total / state.seedCrop.pageSize)

const SeedCropSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  addError,
  seedCropDicts,
  ids,
  seedCrop,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  seedCropList,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  pages,
}

export default SeedCropSelectors
